<template>
  <div class="user">
    <div class="user_bg"></div>
    <div class="info">
      <img class="profile" src="../assets/default_profile.png" />
      <span class="uname">{{ userName }}</span>
      <div class="role-tags">
        <van-tag class="role-tag" type="warning" size="medium" v-if="isHeadTeacher"
          >班主任</van-tag
        >
        <van-tag class="role-tag" :type="roleTagType" size="medium">{{
          roleText
        }}</van-tag>
      </div>
    </div>
  </div>

  <!-- 家长功能入口 -->
  <van-cell-group inset style="margin-top: 40px" v-if="role === 'parent'">
    <van-cell title="我的孩子" is-link @click="toChild">
      <template #icon>
        <van-icon name="friends-o" class="menu-icon" color="#52C1B2" />
      </template>
    </van-cell>
    <van-cell title="已报名课程" is-link @click="toMyEnrolled">
      <template #icon>
        <van-icon name="notes-o" class="menu-icon" color="#52C1B2" />
      </template>
    </van-cell>
    <van-cell title="课程缴费" is-link @click="toPayment">
      <template #icon>
        <van-icon name="gold-coin-o" class="menu-icon" color="#ff9800" />
      </template>
    </van-cell>
    <van-cell title="请假管理" is-link @click="toLeaveList">
      <template #icon>
        <van-icon name="notes-o" class="menu-icon" color="#07c160" />
      </template>
    </van-cell>
  </van-cell-group>

  <!-- 老师功能入口 -->
  <van-cell-group inset style="margin-top: 40px" v-if="role === 'teacher'">
    <van-cell title="我的班级" is-link @click="toClassList" v-if="isHeadTeacher">
      <template #icon>
        <van-icon name="friends-o" class="menu-icon" color="#52C1B2" />
      </template>
    </van-cell>
    <van-cell title="请假管理" is-link @click="toLeaveManage" v-if="isHeadTeacher">
      <template #icon>
        <van-icon name="description" class="menu-icon" color="#ff976a" />
      </template>
    </van-cell>
  </van-cell-group>

  <!-- 通用功能 -->
  <van-cell-group inset style="margin-top: 10px">
    <van-cell title="账号" is-link @click="toAccount">
      <template #icon>
        <van-icon name="contact" class="menu-icon" color="#607d8b" />
      </template>
    </van-cell>
    <van-cell title="关于" is-link @click="toAbout">
      <template #icon>
        <van-icon name="info-o" class="menu-icon" color="#607d8b" />
      </template>
    </van-cell>
  </van-cell-group>

  <div style="margin: 100px 30px">
    <van-button round block color="#ee0a24" plain native-type="submit" @click="onLogout">
      退出账号
    </van-button>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { Cell, CellGroup } from "vant";
import { ROLE_TEXT, clearLoginState } from "../utils/auth";

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  setup() {
    const router = useRouter();
    const userName = ref("");

    // 角色判断
    const role = computed(() => {
      const type = sessionStorage.getItem("role");
      if (type == 2 || type == 3 || type == 6) return "teacher";
      return "parent";
    });

    // 与账号页、登录落库共用同一份角色文案，避免三处各写一份
    const roleText = computed(() => {
      return ROLE_TEXT[Number(sessionStorage.getItem("role"))] || "家长";
    });

    const roleTagType = computed(() => {
      return role.value === "teacher" ? "success" : "primary";
    });

    // 是否班主任（只有班主任显示请假审核）
    const isHeadTeacher = computed(() => {
      return sessionStorage.getItem("isHeadTeacher") === "true";
    });

    const toAbout = () => router.push({ path: "/about" });
    const toChild = () => router.push({ path: "/child" });
    const toMyEnrolled = () => router.push({ path: "/myEnrolled" });
    const toPayment = () => router.push({ path: "/payment" });
    const toSchedule = () => router.push({ path: "/schedule" });
    const toLeaveList = () => router.push({ path: "/leaveList" });
    const toLeaveManage = () => router.push({ path: "/leaveManage" });
    const toClassList = () => router.push({ path: "/headTeacherClassList" });

    const onLogout = () => {
      // 只清登录态：已保存账号列表(savedAccounts)与微信 openId 要留着，
      // 否则退出一次"账号"页里的切换列表就空了
      clearLoginState();
      router.replace("/");
    };

    const toAccount = () => router.push({ path: "/account" });

    onMounted(() => {
      userName.value = sessionStorage.getItem("userName");
    });

    return {
      userName,
      role,
      roleText,
      roleTagType,
      isHeadTeacher,
      onLogout,
      toAbout,
      toAccount,
      toChild,
      toMyEnrolled,
      toPayment,
      toSchedule,
      toLeaveList,
      toLeaveManage,
      toClassList,
    };
  },
};
</script>

<style lang="less">
.user {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;

  .user_bg {
    position: absolute;
    width: 140%;
    height: 180px;
    left: -20%;
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
    background-image: linear-gradient(0deg, #52c1b2, #52c1b2 50%);
    z-index: 0; // 背景垫底；原 -1 会把头部压到背景层，部分 WebView 下整个头部不可见
  }

  .info {
    position: relative;
    z-index: 1;
    width: 120px;
    height: 120px;
    margin: 0 auto;
    margin-top: 30px;

    .profile {
      display: block;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin: 0 auto;
    }
    .uname {
      display: block;
      width: 120px;
      margin-top: 10px;
      text-align: center;
      color: #fff;
      font-size: 14px;
    }
    .role-tags {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 8px;
    }
    .role-tag {
      display: inline-block;
      width: fit-content;
    }
  }
}

.menu-icon {
  margin-right: 8px;
  font-size: 20px;
}
</style>
